import type { ComponentProps } from "react"
import { cn } from "~/lib/utils"

export function ColorSwatch({
	color,
	size = "sm",
	className,
	...props
}: Omit<ComponentProps<"span">, "color"> & {
	color: string
	size?: "xs" | "sm" | "md"
}) {
	return (
		<span
			aria-hidden
			className={cn(
				"inline-block shrink-0 rounded-full",
				size === "xs" && "size-2",
				size === "sm" && "size-2.5",
				size === "md" && "size-3.5",
				className
			)}
			style={{ backgroundColor: color }}
			{...props}
		/>
	)
}
